import * as angular from 'angular';
import * as _ from 'lodash';

interface ILegendItemContext {
    id: number;
    name: string;
    ref: string;
    selected: boolean;
}

interface ILegendScope extends angular.IScope {
    selectedId: number;
    group: string;
    model: ILegendItemContext[];
    change: () => void;
}

class LegendDirective implements angular.IDirective {
    readonly replace = true;
    readonly restrict = 'E';
    readonly scope = {
        group: '@?',
        model: '=ngModel',
        change: '&?ngChange'
    };

    readonly require = 'ngModel';
    readonly template = `
        <div class="fc-legend">
            <div
                ng-repeat="item in model track by $index"
                class="fc-legend-item fc-legend-{{ item.ref }}"
                ng-class="{ 'fc-legend-selected': item.selected }"
                layout="row"
            >
                <fc-checkbox ng-if="!group" ng-model="item.selected" ng-change="change({ id: item.id, selected: checked })">
                </fc-checkbox>
                <fc-radio ng-if="group" group="{{ group }}" ng-value="item.id" ng-model="selectedId" ng-change="change({ id: value })">
                </fc-radio>
                <div ng-if="item.name" class="fc-legend-name">{{ item.name }}</div>
            </div>
        </div>
    `;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(
        scope: ILegendScope,
        _element: JQuery,
        _attributes: angular.IAttributes,
        controller: angular.INgModelController
    ): void {
        scope.change = scope.change || angular.noop;

        // For group based selection a radio button is used
        // We need to get the selected id as the model
        this.resolveSelectedId(scope);

        // We also watch the model for changes so the selected id can be updated
        scope.$watch(
            () => controller.$modelValue,
            () => this.resolveSelectedId(scope)
        );
    }

    private resolveSelectedId(scope: ILegendScope): void {
        if (scope.group && scope.model) {
            const selected = _.find(scope.model, item => item.selected);

            if (selected) {
                const { id } = selected;
                scope.selectedId = id;
            }
        }
    }
}

const LegendDirectiveFactory: angular.IDirectiveFactory = () => new LegendDirective();

export { LegendDirectiveFactory };
